import type React from 'react';
import { Text, Link } from '@farmersdog/corgi-x';
import { FRESH_CX_PHONE } from '@farmersdog/constants/phoneNumbers';
import { CtaTrackerV2, HomepageRedesignSections } from '../../../CtaTrackerV2';
import styles from './GiveUsACall.module.css';

export const GiveUsACall: React.FC = () => (
  <>
    <CtaTrackerV2
      type="select"
      moduleLevel={1}
      moduleName={HomepageRedesignSections.Hero}
    >
      <Link type="anchor" href={`tel:${FRESH_CX_PHONE.link}`}>
        <Text
          variant="heading-16"
          color="kale-3"
          as="div"
          className={styles.giveUsACallMobile}
        >
          Or Give Us a Call
        </Text>
      </Link>
    </CtaTrackerV2>
    <Text
      variant="heading-16"
      color="kale-3"
      as="div"
      className={styles.giveUsACallDesktop}
    >
      Or give us a call {FRESH_CX_PHONE.display}
    </Text>
  </>
);
